module.exports = __webpack_public_path__ + "fonts/lato-light-webfont.dbec4ba3.ttf";